import React from "react";
import "./DataSecurity.css";

function DataSecurity() {
  return (
    <div className="diligencia-security-container">
      {/* Hero Header Section */}
      <header className="security-hero">
        <div className="security-hero-overlay"></div>
        <div className="security-hero-content">
          <div className="security-badge">
            <i className="fa-solid fa-shield-halved"></i> Trust &amp; Protection
          </div>
          <h1>Data Security &amp; Confidentiality</h1>
          <p className="security-lead">
            At Diligencia Solutions &amp; Services Pvt. Ltd., safeguarding
            client information is not just an operational requirement—it is a
            core business principle built into everything we do.
          </p>
        </div>
      </header>

      {/* Main Content Area */}
      <div className="container">
        <div className="security-content-wrapper">
          {/* Core Controls Grid Section */}
          <section className="security-grid-section">
            <div className="section-title-block">
              <h2>Our Multi-Layered Security Infrastructure</h2>
              <div className="title-accent-line"></div>
            </div>

            <div className="security-cards-grid">
              {/* Box 1: Administrative Controls */}
              <div className="security-card">
                <div className="card-header-group">
                  <div className="card-icon-wrapper admin-icon">
                    <i className="fa-solid fa-user-gear"></i>
                  </div>
                  <h3>Administrative Controls</h3>
                </div>
                <p className="card-intro">
                  Governing corporate policies, compliance metrics, and human
                  resource security parameters.
                </p>
                <ul className="security-points-list">
                  <li>
                    <i className="fa-solid fa-circle-check"></i>
                    <span>
                      <strong>Role-Based Access Management:</strong> Permissions
                      are dynamically provisioned based on explicit team duties.
                    </span>
                  </li>
                  <li>
                    <i className="fa-solid fa-circle-check"></i>
                    <span>
                      <strong>Employee Confidentiality Obligations:</strong>{" "}
                      Every personnel layer signs legal binding agreements prior
                      to system access.
                    </span>
                  </li>
                  <li>
                    <i className="fa-solid fa-circle-check"></i>
                    <span>
                      <strong>Security Awareness Practices:</strong> Routine
                      mandatory training modules addressing phishing, social
                      engineering, and safe data habits.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Box 2: Operational Controls */}
              <div className="security-card">
                <div className="card-header-group">
                  <div className="card-icon-wrapper ops-icon">
                    <i className="fa-solid fa-sliders"></i>
                  </div>
                  <h3>Operational Controls</h3>
                </div>
                <p className="card-intro">
                  Protecting the live production environments where client data
                  assets are actively managed.
                </p>
                <ul className="security-points-list">
                  <li>
                    <i className="fa-solid fa-circle-check"></i>
                    <span>
                      <strong>Controlled Data Access:</strong> Rigid
                      multi-factor barriers protecting shared files from random
                      external discovery.
                    </span>
                  </li>
                  <li>
                    <i className="fa-solid fa-circle-check"></i>
                    <span>
                      <strong>Need-to-Know Access Principles:</strong> Staff
                      members only access files vital to completing their
                      current task segment.
                    </span>
                  </li>
                  <li>
                    <i className="fa-solid fa-circle-check"></i>
                    <span>
                      安全<strong>Project-Specific Authorization:</strong>{" "}
                      Siloed server permissions prevent cross-contamination
                      across active brand accounts.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Box 3: Information Handling */}
              <div className="security-card full-width-card">
                <div className="card-header-group">
                  <div className="card-icon-wrapper handling-icon">
                    <i className="fa-solid fa-box-archive"></i>
                  </div>
                  <h3>Information Handling</h3>
                </div>
                <p className="card-intro">
                  Enforcing protocols for asset life cycles, covering storage
                  transitions through total media destruction.
                </p>

                <div className="handling-subgrid">
                  <div className="handling-item">
                    <h4>
                      <i className="fa-solid fa-shuffle"></i> Secure
                      Transmission
                    </h4>
                    <p>
                      All transactional corporate workloads leverage robust
                      programmatic data encryption during system transits.
                    </p>
                  </div>
                  <div className="handling-item">
                    <h4>
                      <i className="fa-solid fa-folder-tree"></i> Controlled
                      Management
                    </h4>
                    <p>
                      Strict structural versioning protocols preserve historical
                      files while protecting them against malicious overwrites.
                    </p>
                  </div>
                  <div className="handling-item">
                    <h4>
                      <i className="fa-solid fa-trash-can"></i> Retention &amp;
                      Disposal
                    </h4>
                    <p>
                      Archived assets are cleared permanently through digital
                      shredding algorithms when validation parameters expire.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Confidentiality Commitment Section */}
          <section className="confidentiality-banner">
            <div className="commitment-inner">
              <div className="commitment-header">
                <div className="shield-badge">
                  <i className="fa-solid fa-lock-open"></i>
                </div>
                <h2>Our Strict Confidentiality Commitment</h2>
              </div>
              <div className="commitment-text">
                <p>
                  All employees, contractors, third-party partners, and
                  operational stakeholders are explicitly required to maintain
                  unwavering confidentiality regarding proprietary client
                  knowledge profiles.
                </p>
                <blockquote className="security-quote">
                  "Client information assets are never exposed, leased, or
                  disclosed to unauthorized external entities without prior
                  explicit corporate consent or direct statutory legal
                  mandates."
                </blockquote>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default DataSecurity;
